
// A web socket connection with automatic reconnect
//
// Usage: newConnection( {
//   addr: '127.0.0.1',
//   onMsgReceived: myMsgReceived,
//   onReconnect: myReconnect,
//   onConnectStarting: myConnStarting,
//   onError: myError,
//   getTokenFunc: myGetTokenFunc
//   })
// Protocal can be set, such as for 'janus-protocol' webrtc
function newConnection (cfg) {
  let _socketAddr = cfg.addr
  let _publishSocketMessageReceived = cfg.onMsgReceived
  let _publishSocketReconnect = cfg.onReconnect
  let _publishSocketConnectStarting = cfg.onConnectStarting
  let _publishSocketError = cfg.onError
  let _socket
  let _reconnectTimeout = 3000
  let _stopping = false
  let _protocol = cfg.protocol
  let _getTokenFunc = cfg.getTokenFunc
  let _log = false

  function reconnect () {
    if (_stopping) {
      return
    }
    setTimeout(start, _reconnectTimeout)
  }

  function start () {
    if (_log) {
      console.log('connecting to ' + _socketAddr)
    }

    if (_socket != null) {
      if (_socket.readyState === WebSocket.CONNECTING ||
        _socket.readyState === WebSocket.OPEN) {
        return
      }
    }

    if (_publishSocketConnectStarting) {
      _publishSocketConnectStarting()
    }

    if (_getTokenFunc) {
      // For secure socket connections requiring a token
      let token = _getTokenFunc()
      if (!token) {
        return
      }
      _socket = new WebSocket(_socketAddr + `?token=${token}`, _protocol)
    } else {
      _socket = new WebSocket(_socketAddr, _protocol)
    }

    _socket.onclose = () => {
      reconnect()
    }

    _socket.onerror = () => {
      if (_publishSocketError) {
        _publishSocketError()
      }
      reconnect()
    }

    _socket.onmessage = (evt) => {
      const data = JSON.parse(evt.data)
      _publishSocketMessageReceived(data)
    }

    _socket.onopen = () => {
      _publishSocketReconnect()
    }
  }

  function stop () {
    _stopping = true
    if (_socket) {
      _socket.close()
      _socket = null
    }
  }

  function send (v) {
    if (_stopping) {
      return
    }
    if (!_socket) {
      return
    }

    // console.log('sending: ' + JSON.stringify(v))
    _socket.send(JSON.stringify(v))
  }

  return {
    start: start,
    stop: stop,
    send: send
  }
}

//export default {
//  newConnection
//}
